module.exports = __webpack_public_path__ + "img/matrix-bus.jpg.fca5f926.webp";